<template>
  <div @click.stop.prevent class="animate-component" :style="computedStyle">
    <img :src="imgSrc" alt="" />
  </div>
</template>

<script>
import eventMixin from "utils/event/eventMixin.js"
export default {
  mixins: [eventMixin],
  name: "cxAnimate",
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {}
  },
  mounted() {},
  computed: {
    imgSrc() {
      if (this.options.isOnlinelRes) {
        return this.options.imgSrc
      } else {
        return require("assets/images/leftMenu/animate/" + this.options.imgSrc)
      }
    },
    computedStyle() {
      return {
        width: this.options.width + "px",
        height: this.options.height + "px",
        transform: "rotate(" + this.options.rotate + "deg)"
      }
    }
  },
  methods: {}
}
</script>

<style scoped>
.animate-component {
  /*padding: 16px;*/
  /*box-sizing: border-box;*/
}
.animate-component img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
